import { AbstractCommand } from 'src/models/command';

class CommandBuilder {
	public readonly commandBusURL: string;

	constructor(commandBusURL: string) {
		this.commandBusURL = commandBusURL + '/command';
	}

	public build(command: AbstractCommand): FormData {
		const formData = new FormData();
		formData.append('command', command.name);

		formData.append('parameters', JSON.stringify(command.parameters));
		formData.append('apiVersion', String(command.apiVersion));
		formData.append('processId', command.processId);
		formData.append('async', command.async.toString());
		formData.append('serializer', 'pako');
		return formData;
	}
}

export { CommandBuilder };
